import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

import { SHARED_MODULES } from '../../../shared.';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
	imports: [SHARED_MODULES, PhIconComponent, PhIconWrapperComponent],
    standalone: true
})
export class SearchComponent implements OnInit {
	formControl: FormControl<string>;

	@Input() dynamicSearch: boolean = true;
	@Input('disabled') set setDisabled(value: boolean) {
		if (value) {
			this.formControl.disable({ emitEvent: false });
		} else {
			this.formControl.enable({ emitEvent: false });
		}
	}
	@Input('value') set setValue(value: string) {
		this.formControl.setValue(value, { emitEvent: false });
	}

	@Output('search') onSearchEmitter: EventEmitter<string> = new EventEmitter<string>();

	constructor(private formBuilder: FormBuilder) {
		this.formControl = this.formBuilder.control<string>('');
	}

	ngOnInit(): void {
		this.formControl.valueChanges
			.pipe(debounceTime(500))
			.subscribe((value: string): void => {
				if (this.dynamicSearch) this.onSearchEmitter.emit(value);
			});
	}

	clearValue(): void {
		this.formControl.setValue('');
		if (!this.dynamicSearch) this.onSearchEmitter.emit('');
	}

	handleEnterKey(): void {
		if (!this.dynamicSearch) this.onSearchEmitter.emit(this.formControl.value);
	}

	handleFocusOut(event: FocusEvent): void {
		const relatedTarget = event.relatedTarget as HTMLElement;
		if (relatedTarget?.closest('ph-icon-wrapper')) return;
		if (!this.dynamicSearch) this.onSearchEmitter.emit(this.formControl.value);
	}
}